import { SFC_LICENCE_TYPES } from "./sfcLicences";

export const IA_LICENCE_TYPES = [
  {
    name: "l1",
    label: "I    -  Principles & Practices of Insurance (保險原則與實踐)",
  },
  { name: "l2", label: "II   -  General Insurance (一般保險)" },
  { name: "l3", label: "III  -  Long Term Insurance (長期保險)" },
  { name: "l4", label: "IV   -  MPF (強積金)" },
  {
    name: "l5",
    label: "V    -  Investment Link Long Term Insurance (投資相連長期保險)",
  },
];

export const formatUserLicenceHoldings = (user) => {
  const labels = [];
  const licences = user?.consultantInfo?.licences ?? {};
  const sfcLicences = user?.consultantInfo?.sfcLicences ?? {};

  IA_LICENCE_TYPES.forEach(({ name, label }) => {
    if (licences[name]) labels.push(label.split("-")[0].trim());
  });

  SFC_LICENCE_TYPES.forEach(({ name, labelKey }) => {
    if (sfcLicences[name]) labels.push(labelKey);
  });

  return labels.length ? labels.join(", ") : "--";
};

export const formatQuizTargetLicences = (quiz) => {
  if (quiz?.noLicenceNeed !== false) return "All users in role (no licence filter)";

  const parts = [];
  (quiz.requiredLicenses ?? []).forEach((key) => {
    const found = IA_LICENCE_TYPES.find((l) => l.name === key);
    if (found) parts.push(found.label.split("-")[0].trim());
  });
  (quiz.requiredSfcLicences ?? []).forEach((key) => {
    const found = SFC_LICENCE_TYPES.find((l) => l.name === key);
    if (found) parts.push(found.labelKey);
  });

  return parts.length ? parts.join(", ") : "No licences selected";
};

export const licencesToArrays = (iaForm, sfcForm) => ({
  requiredLicenses: Object.entries(iaForm ?? {})
    .filter(([, v]) => v)
    .map(([k]) => k),
  requiredSfcLicences: Object.entries(sfcForm ?? {})
    .filter(([, v]) => v)
    .map(([k]) => k),
});

export const arraysToLicenceForms = (requiredLicenses = [], requiredSfcLicences = []) => {
  const iaForm = { l1: false, l2: false, l3: false, l4: false, l5: false };
  const sfcForm = { type1: false, type4: false, type9: false };
  requiredLicenses.forEach((k) => {
    if (iaForm[k] !== undefined) iaForm[k] = true;
  });
  requiredSfcLicences.forEach((k) => {
    if (sfcForm[k] !== undefined) sfcForm[k] = true;
  });
  return { iaForm, sfcForm };
};
